/* eslint-disable */
import { createBaseReport, createForm, deleteForm,deleteReport, updateForm, formByID, formList, formDetails} from "@/api/form_ec16c";
import store from "@/store";

export const addBaseReport = ({ commit }, payload) => {
  return new Promise((resolve) => {
    createBaseReport(payload).then((response) => {
      if (response.status_code === 201) {
        resolve(response);
      }
    });
  });
};

export const addForm = ({ commit }, payload) => {
  return new Promise((resolve) => {
    createForm(payload).then((response) => {
      if (response.status_code === 201) {        
        let data = {
					type: payload.report_type,
					formID: payload.report_id,
				};

				getFormDetails(commit, data);

        resolve(response);
      }
    });
  });
};

export const editForm = ({ commit }, payload) => {
  return new Promise((resolve) => {
    updateForm(payload).then((response) => {
      if (response.status_code === 201) {

				getFormByID(commit, { formID: payload.get("report_id") });

        resolve(response);
      }
    });
  });
};

export const deleteReportRecord = ({ commit }, payload) => {
  return new Promise((resolve) => {
    deleteReport(payload).then((response) => {      
      if (response.status_code === 200) {
        getFormList(commit, {party_id: ""});

        resolve(response);
      }
    });
  });
};

export const deleteFormRecord = ({ commit }, payload) => {
  return new Promise((resolve) => {
    deleteForm(payload).then((response) => {      
      if (response.status_code === 200) {
        if (payload.page && payload.page == "details") {
          getFormByID(commit, { formID: payload.report_id });
        }else{
          let data = {
            type: payload.report_type,
            report_id: payload.report_id,
            item_id: payload.item_id,
            formID: payload.report_id,
          };
  
          getFormDetails(commit, data);
        }

        resolve(response);
      }
    });
  });
};

// export const editForm = ({ commit }, payload) => {
//   return new Promise((resolve) => {
//     updateForm(payload).then((response) => {
//       if (response.status_code === 201) {
//         getFormList();
//       }
//       resolve("success");
//     });
//   });
// };


export const getFormByID = ({ commit }, payload) => {
  return new Promise((resolve) => {
    formByID(payload).then((response) => {
      if (response.status_code === 200) {
        store.commit("form_ec16c/setSingleForm", response.data);
      }
      resolve();
    });
  });
};

export const getFormList = ({ commit }, payload) => {
  return new Promise((resolve) => {    
    formList(payload).then((response) => {
      if (response.status_code === 200) {
        store.commit("form_ec16c/setForms", response.data);
      }
      resolve();
    });
  });
};

export const getFormDetails = (commit, payload) => {
  return new Promise((resolve) => {
    formDetails(payload).then((response) => {
      
      if (response.status_code === 200) {
        if (payload.type == "amount_received") {
          store.commit("form_ec16c/setIncome", response.data);
        }
        
        if (payload.type == "amount_expended") {
          store.commit("form_ec16c/setExpenditures", response.data);
        }
        
        if (payload.type == "contributions_donations") {
          store.commit("form_ec16c/setDonations", response.data);
        }
        
        if (payload.type == "assets") {
          store.commit("form_ec16c/setAssets", response.data);
        }
        if (payload.type == "liabilities") {
          store.commit("form_ec16c/setLiabilities", response.data);
        }
        if (payload.type == "bank_details") {
          store.commit("form_ec16c/setBankDetails", response.data);
        }
      }
      resolve();
    });
  });
};